'use strict';exports.__esModule = true;var _react = require('react');
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

WindowDimentionManager = function (_Component) {_inherits(WindowDimentionManager, _Component);function WindowDimentionManager() {var _temp, _this, _ret;_classCallCheck(this, WindowDimentionManager);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.









    resizeHandler = function () {
      var width = global.document.body.clientWidth;
      var height = global.document.body.clientHeight;
      _this.props.onDimentionsChange({ width: width, height: height });
    }, _temp), _possibleConstructorReturn(_this, _ret);}WindowDimentionManager.prototype.componentDidMount = function componentDidMount() {window.addEventListener('resize', this.resizeHandler);this.resizeHandler();};WindowDimentionManager.prototype.componentWillUnmount = function componentWillUnmount() {window.removeEventListener('resize', this.resizeHandler);};WindowDimentionManager.prototype.

  render = function render() {
    return null;
  };return WindowDimentionManager;}(_react.Component);


WindowDimentionManager.propTypes = {
  onDimentionsChange: _propTypes2.default.func.isRequired };exports.default =


WindowDimentionManager;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/WindowDimentionManager.js
// module id = 3065
// module chunks = 0